module.exports = __webpack_public_path__ + "img/1527878508.81d62f25.jpg";